import { memo } from "react";
import { FormControl, FormField, FormItem } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { FormFieldProps } from "./types";
import { useTranslation } from "react-i18next";

const TextField = memo(({ config, control }: FormFieldProps) => {
  const { t } = useTranslation();
  return (
    <div>
      <FormField
        control={control}
        name={config.name}
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <Input
                {...field}
                value={field.value}
                label={t(config.label ?? "")}
                id={field.name}
                tootltip={config.tooltip}
                type="text"
                disabled={config.disabled}
                ref={field.ref}
              />
            </FormControl>
          </FormItem>
        )}
      />
      {config.separator && <Separator className="my-4" />}
    </div>
  );
});

TextField.displayName = "TextField";
export default TextField;
